<!--
 * @Author: chenxing
 * @Date: 2021-03-12 14:22:13
 * @LastEditors: LiuXin
 * @LastEditTime: 2021-10-08 17:49:59
-->
<template>
  <a-layout-header class="layout_header">
    <div class="fixed_wrapper">
      <div class="material-logo">
        <img src="../../assets/image/logo_with_txt.png" />
      </div>
      <div v-if="!hideTags && !isMobile" id="router_tags">
        <a-tag v-if="showArrow" class="pre_tag" @click="scrollTags(-1)"><DoubleLeftOutlined /></a-tag>
        <div id="router_tag_list">
          <template v-for="(tag, index) in tagList">
            <a-checkable-tag class="router_tag" v-if="tag.meta.title" closable :checked="currentTag(tag)" :key="tag.path" @click="goto(tag)">
              {{ tag.meta.title }}
              <CloseOutlined v-show="tagList.length != 1" @click.stop="closeTag(tag, index)" />
            </a-checkable-tag>
          </template>
        </div>
        <a-tag v-if="showArrow" class="next_tag" @click="scrollTags(1)" style="margin-left: 10px"><DoubleRightOutlined /></a-tag>
      </div>
      <div class="header-right">
        <!-- <NoticeBox class="notice-box-wrapper" :notice-lists="noticeLists"></NoticeBox> -->
        <a-dropdown v-if="centerVisible" class="user-avatar-menu" placement="topRight" overlay-class-name="profile-dropdown">
          <SmallDashOutlined @click.prevent class="mr30" />
          <template #overlay>
            <a-menu>
              <a-menu-item>
                <router-link tag="a" target="_blank" to="/center/task">任务中心</router-link>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
        <a-dropdown class="user-avatar-menu" placement="topRight" overlay-class-name="profile-dropdown">
          <a class="ant-dropdown-link" @click.prevent>
            {{ userCode }}
            <DownOutlined />
          </a>
          <template #overlay>
            <a-menu>
              <a-menu-item>
                <ProfileOutlined />
                <router-link to="/user">个人资料</router-link>
              </a-menu-item>
              <a-menu-item class="menu-item-logout">
                <LogoutOutlined />
                <a href="javascript:;" @click="logout">注销登录</a>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </div>
    </div>
  </a-layout-header>
</template>

<script>
import { DownOutlined, LogoutOutlined, ProfileOutlined, CloseOutlined, DoubleRightOutlined, DoubleLeftOutlined, SmallDashOutlined } from '@ant-design/icons-vue';
import canvasMask from '@/utils/pagemask.js';
import { mapState } from 'vuex';

export default {
  components: {
    DownOutlined,
    LogoutOutlined,
    ProfileOutlined,
    CloseOutlined,
    DoubleRightOutlined,
    DoubleLeftOutlined,
    SmallDashOutlined,
  },
  data() {
    return {
      noticeLists: [],
      showArrow: false,
      hideTags: null,
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.oauth.userInfo,
      userCode: state => state.oauth.userInfo.userCode,
      userId: state => state.oauth.userInfo.userId,
      jobs: state => state.oauth.userInfo.jobs,
    }),
    centerVisible() {
      return (
        (this.jobs === 'OPERATION' || this.jobs === 'MEDIUM' || this.jobs === 'ADMIN') &&
        this.userInfo?.menuList.findIndex(item => {
          return item.name == '任务中心';
        }) !== -1
      );
    },
    // 当前选中的router-tag
    currentTag() {
      return tag => {
        return tag.path === this.$route.path;
      };
    },
    // 展示出来的所有router-tag
    tagList() {
      // 是否展示滚动tagList的左右箭头
      const outDiv = document.getElementById('router_tag_list');
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.showArrow = outDiv && outDiv.scrollWidth > outDiv.clientWidth;
      return this.$store.state.routerTags.filter(item => item && item.path != '/login');
    },
    isMobile() {
      const sUserAgent = navigator.userAgent.toLowerCase();
      let bIsIphone = sUserAgent.match(/iphone os/i) == 'iphone os';
      let bIsAndroid = sUserAgent.match(/android/i) == 'android';
      return bIsIphone || bIsAndroid;
    },
  },
  mounted() {
    this.toggleMask(this.$route.meta.showMask);
    this.getHideTags(this.$route.meta.hideTags);
    this.$watch('$route', newVal => {
      this.getHideTags(newVal.meta.hideTags);
      this.toggleMask(newVal.meta.showMask);
    });
    window.addEventListener('mousewheel', this.scrollTags, { passive: false }); //添加监听事件
  },
  beforeMount() {
    window.removeEventListener('mousewheel', this.scrollTags); //移除监听事件
  },
  methods: {
    toggleMask(showMask) {
      showMask ? canvasMask.createMask({ container: document.getElementsByClassName('ant-layout ant-layout-main')[0], content: `${this.userCode}` }) : canvasMask.deleteMask();
    },
    getHideTags(hideTags) {
      this.hideTags = hideTags;
    },
    // 退出登录
    logout() {
      localStorage.removeItem('videoFilterCondition');
      localStorage.removeItem('imageFilterCondition');
      this.$store.dispatch('oauth/Logout').then(() => {
        this.$router.push({
          name: 'login',
        });
        this.$store.commit('REMOVE_ROUTERTAGS', { clear: true });
      });
    },
    // router-tag-list滚动
    scrollTags(num) {
      const outDiv = document.getElementById('router_tag_list');
      if (num && num === 1) {
        scroll(num);
        return;
      } else if (num === -1) {
        scroll(num);
        return;
      }
      if (outDiv) {
        outDiv.addEventListener('mousewheel', fun, { passive: false });
        function fun(event) {
          //禁止事件默认行为（此处禁止鼠标滚轮行为关联到"屏幕滚动条上下移动"行为）
          event.preventDefault();
          //设置鼠标滚轮滚动时屏幕滚动条的移动步长
          scroll(event.deltaY);
        }
        function scroll(num) {
          let step = 50;
          if (num < 0) {
            //向上滚动鼠标滚轮，屏幕滚动条左移
            outDiv.scrollLeft -= step;
          } else {
            //向下滚动鼠标滚轮，屏幕滚动条右移
            outDiv.scrollLeft += step;
          }
        }
      }
    },
    // 点击router-tag跳转
    goto(tag) {
      this.$store.commit('SET_CURRENTTAG', tag);
      if (tag.path != this.$route.path) {
        this.$router.push(tag.path);
      }
    },
    // 关闭tag
    closeTag(tag, index) {
      this.$store.commit('REMOVE_ROUTERTAGS', { tag: tag });
      if (tag.path != this.$route.path) {
        return;
      }
      // 如果是最后一个就切换到前一个
      if (index === this.tagList.length) {
        index -= 1;
      }
      // 删除后切换到下一个
      const nextTag = this.tagList.slice(index)[0];
      this.goto(nextTag);
    },
  },
};
</script>
<style lang="less" scoped>
.layout_header {
  background: #fff;
  padding: 0;
  height: 48px;
  line-height: 48px;
  position: relative;
  // width: 100vw;
  .fixed_wrapper {
    left: 0;
    width: 100vw;
    position: fixed;
    height: 48px;
    display: flex;
    background-color: #fff;
    z-index: 13;
  }
}
.ant-dropdown-link {
  height: 50px;
}
.header-right {
  margin: 0 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.notice-box-wrapper {
  margin-right: 1rem;
}

.menu-item-logout {
  border-top: 1px solid #eee;
}
#router_tags {
  height: 48px;
  display: flex;
  flex-grow: 1;
  align-items: center;
  margin-left: 12px;
  #router_tag_list {
    width: 10px;
    flex-grow: 1;
    display: flex;
    align-items: center;
    overflow-y: hidden;
    flex-wrap: nowrap;
    &::-webkit-scrollbar {
      height: 0 !important;
    }
    .router_tag {
      .anticon-close {
        opacity: 0;
      }
      &:hover {
        .anticon-close {
          opacity: 1;
        }
      }
    }
  }
  .ant-tag {
    height: 30px;
    line-height: 30px;
    background: #eef2f6;
    border-radius: 2px;
    border: 0;
    &.ant-tag-checkable-checked {
      background: #2f70f4;
      .anticon-close {
        color: white;
      }
    }
  }
}
.material-logo {
  height: 48px;
  width: 185px;
  line-height: 48px;
  text-align: center;
  background: #2f70f4;
}
</style>
<style lang="less">
.profile-dropdown {
  position: fixed !important;
  top: 53px !important;
  .ant-dropdown-menu-item {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>